/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Overrides_Manual_TitleInputs */

const fr_style_overrides_manual_title = /** @type {(inputs: Style_Overrides_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montage manuel`)
};

const en_style_overrides_manual_title = /** @type {(inputs: Style_Overrides_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual mount`)
};

/**
* | output |
* | --- |
* | "Manual mount" |
*
* @param {Style_Overrides_Manual_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_manual_title = /** @type {((inputs?: Style_Overrides_Manual_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_Manual_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_manual_title(inputs)
	return en_style_overrides_manual_title(inputs)
});